var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.667,
    r: 15,
    fill: "#FF947A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 11.167C9.5 9.51014 10.8431 8.16699 12.5 8.16699H17V11.167C17 12.8238 18.3431 14.167 20 14.167H21.5V20.167C21.5 21.8238 20.1569 23.167 18.5 23.167H12.5C10.8431 23.167 9.5 21.8238 9.5 20.167V11.167ZM12.5 14.917C12.0858 14.917 11.75 15.2528 11.75 15.667C11.75 16.0812 12.0858 16.417 12.5 16.417H14C14.4142 16.417 14.75 16.0812 14.75 15.667C14.75 15.2528 14.4142 14.917 14 14.917H12.5ZM12.5 17.917C12.0858 17.917 11.75 18.2528 11.75 18.667C11.75 19.0812 12.0858 19.417 12.5 19.417H15.5C15.9142 19.417 16.25 19.0812 16.25 18.667C16.25 18.2528 15.9142 17.917 15.5 17.917H12.5ZM19.0113 9.81608L18.9131 11.2892C18.883 11.7419 19.2586 12.1176 19.7114 12.0874L21.1844 11.9892C21.8274 11.9463 22.1205 11.1661 21.6649 10.7105L20.29 9.33564C19.8344 8.88001 19.0542 9.17314 19.0113 9.81608Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.2d19b673c8d64d5a3ce3246791da1489.svg";
export { ForwardRef as ReactComponent };